import { saveActivityFilterGridState as saveActivityFilterGridStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    columnState: [];
};

export const saveActivityFilterGridState = ({
    columnState,
}: Props) => {
    saveActivityFilterGridStateDiagram(columnState);
};
